<template>
<!--    <div class="home">-->
<!--        <van-button type="info" @click="goPhoto">信息按钮</van-button>-->
<!--&lt;!&ndash;        <input id="file" type="file" accept="image/*" @onchange="upload('#file', '#img')">&ndash;&gt;-->
<!--        <van-uploader :preview-image="false" v-model="fileList" :after-read="afterRead"/>-->
<!--        -->
<!--        <img v-if="wxImgSrc" :src="wxImgSrc" alt="">-->

<!--    </div>-->
    <div class="home">
        <div class="index_cont">
            <!--        <img :src="require('../../assets/index/facula.png')" alt="" class="bgF">-->
            <!--        <div class="bgFacula"></div>-->
            <img :src="require('@/assets/index/logo_main.png')" alt="" class="index_logo">
            <img :src="require('@/assets/index/title.png')" alt="" class="index_title">
            <div class="home_main" @click="goPhoto">
                <img :src="require('@/assets/home/photo.png')" alt="" class="photo">
            </div>
            <img :src="require('../../assets/home/btn.png')" alt="" class="home_btn" @click="goResult">
        </div>
        <div v-if="imgSrc" class='uploaded-container'>
          <img :src="imgSrc" alt="" class="uploaded-container-photo">
        </div>
        <van-uploader v-show="false" ref="upLoader" :preview-image="false" v-model="fileList" :after-read="afterRead"/>
    </div>
</template>

<script>
  let wx = window.wx
  import { appendJs, setStore } from 'mulan-lib'
  import initWeixin from '@/util/wx'
  import {Toast} from 'vant'
  export default {
    data(){
      return {
        fileList: [],
        imgSrc: '',
        wxImgSrc: ''
      }
    },
      computed: {
        upLoader(){
          return this.$refs.upLoader
        }
      },
      methods: {
        goPhoto(){
          const that = this
          const ua = window.navigator.userAgent.toLowerCase();
          if(ua.match(/MicroMessenger/i) == 'micromessenger') {
            //微信
            initWeixin({
              debug: true,
              shooseInfo: {
                count: 1, // 默认9
                sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                success: function (res) {
                  console.log(res) // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                  that.init(res.localIds)
                }
              }
            },(wx)=>{
              window.wx = wx;
            })
          } else {
            this.upLoader.chooseFile()
          }
        },
        init(localIds) {
          const that = this
          if (!wx) {
            appendJs('https://res.wx.qq.com/open/js/jweixin-1.2.0.js', () => {
              wx = window.wx
              that.getLocalImg(localIds)
            })
          } else {
            that.getLocalImg(localIds)
          }
        },
        getLocalImg(localIds){
          const that = this
          wx.getLocalImgData({
            localId: localIds[0], // 图片的localID
            success: function(res) {
              const localData = res.localData;
              let imageBase64 = '';
              if (localData.indexOf('data:image') == 0) {
                //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                imageBase64 = localData;
              } else {
                //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                //此时一个正常的base64图片路径就完美生成赋值到img的src中了
                imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
              }
              // $('#img').attr('src', imageBase64);
              that.imgSrc = imageBase64
            }
          });
        },
        upload(c,d){
          var $c = document.querySelector(c),
            $d = document.querySelector(d),
            file = $c.files[0],
            reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = function(e){
              console.log(e.target.result)
              $d.setAttribute("src", e.target.result);
            };
        },
        afterRead(file, detail){
          this.imgSrc= file.content
        },
        goResult(){
          console.log(!!this.imgSrc)
          if (!!!this.imgSrc) {
            Toast('请先上传图片')
            return
          }
          setStore('imgSrc', this.imgSrc, 'session')
          this.$router.push({path: '/Result'})
        },
      }
    }
</script>

<style lang="less" scoped>
    .home{
        width: 100%;
        height: 100%;
        background-image: url('../../assets/index/bg.png');
        background-size: cover;
        background-position: 50%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        overflow: auto;
        .uploaded-container {
          position: absolute;
          top: 289px;
          left: 115px;
          width: 145px;
          height: 145px;
          padding: 10px;
          box-sizing: border-box;
          background-color: #fff;
          display: flex;
          justify-content: center;
          &-photo {
            height: 100%;
            width: auto;
            max-width: 100%;
          }
        }

        .index_cont{
            padding-top: 64px;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            background-image: url("../../assets/index/facula.png");
            background-size: cover;
            background-position: 50%;
            background-repeat: no-repeat;

            .bgFacula{
                width: 100%;
                height: 100%;
                background-image: url('../../assets/index/facula.png');
                background-size: cover;
                background-position: 50%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
            }
            .bgF{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
            }
            .index_logo{
                width: 110px;
                height: 85px;
                margin: 0 auto 15px;
            }
            .index_title{
                width: 303px;
                height: 50px;
                margin: 0 auto 15px;
            }
            .home_main{
                width: 247px;
                height: 264px;
                background: #FEF5F7;
                /*opacity: 0.5;*/
                margin: 0 auto;
                position: relative;
                .photo{
                   width: 158px;
                   height: 158px;
                   position: absolute;
                   top: 50%;
                   left: 50%;
                    transform: translateY(-50%) translateX(-50%);
                }
            }
            .home_btn{
                width: 136px;
                height: 36px;
                margin: 27px auto;
            }
            .home_btn:active{
                opacity: 0.8;
            }
        }

    }
</style>
